type PartnerWidgetConfig = {
  title: string;
  icon: {imageUrl: string; alt: string};
  body: string;
  ctaText: string;
  ctaUrl: string;
  ctaTarget?: string;
};

type PartnerState = {
  partnerWidget: PartnerWidgetConfig | null;
};

const initialState: PartnerState = {
  partnerWidget: null,
};

type SetPartnerWidgetAction = {
  type: 'SET_PARTNER_WIDGET';
  partnerWidget?: PartnerWidgetConfig | null;
};

type PartnerAction = SetPartnerWidgetAction | {type: string};

export default function partner(state: PartnerState = initialState, action: PartnerAction): PartnerState {
  switch (action.type) {
    case 'SET_PARTNER_WIDGET':
      return {
        ...state,
        partnerWidget: (action as SetPartnerWidgetAction).partnerWidget || null,
      };
    default:
      return state;
  }
}
